import React, { Component } from "react";
import styled from "styled-components";
import { Redirect } from 'react-router-dom';

// Utils //
import history from "utils/history";

// HOC //
import withChat from "hoc/withChat";

// Components //
import View from 'components/View';
import CodeEditor from "components/CodeEditor";
import Text from "components/Text";
import StepHeader from 'components/StepHeader';
import StepFooter from 'components/StepFooter';
import Callout from 'components/Callout';
import SuccessMessage from 'components/SuccessMessage';
import ErrorMessage from 'components/ErrorMessage';

const Root = styled(View)``;

const Header = styled(StepHeader)`
  margin-bottom: 40px;
`;

class Step4 extends Component {
  state = {
    hasRan: false,
    value: `const messageId = "${this.props.messageId}";

const reaction = await channel.sendReaction(messageId, {
  type: "like"
});

return reaction;`
  };

  run = async () => {
    const { channel, match, setMessageId, setError, setLoading, setStepComplete } = this.props; // eslint-disable-line no-unused-vars
    const { value } = this.state;

    try {
      await setLoading(true);
      const { message } = eval(`(async () => {${value}})();`); // eslint-disable-line no-eval
      setMessageId(message);
      await setStepComplete(3);
      await setLoading(false);

      this.setState({ hasRan: true });
    } catch (err) {
      await setLoading(false);
      setError(err.message);
    }
  };

  handleCodeChange = value => {
    this.setState({
      value
    });
  };

  handlePrevClick = () => history.push(`/step-3`);

  handleNextClick = () => history.push(`/step-5`);

  render() {
    const { client, channel, completedSteps, error, loading } = this.props;
    const { value, hasRan } = this.state;
    const isComplete = completedSteps.includes(3);

    if (!client || !channel) {
      return <Redirect to="/step-1" />
    }
    return (
      <Root>
        <Header
          step={4}
          title="Add a Reaction"
        >
          <Text size={18}>
            If you’re familiar with Facebook Messenger you’ll know the concept of reacting to a message. Below shows an example of how to like a message.
          </Text>
        </Header>
        <CodeEditor
          onChange={this.handleCodeChange}
          onRunClick={this.run}
          value={value}
          runLabel="Add Reaction"
        />
        <Callout
          text="When reading a channel you’ll receive the reaction count for each message."
          style={{marginTop: 24}}
        >
          <Text
            size={15}
          >
            <b>NOTE:</b> When reading a channel you’ll receive the reaction count for each message.
          </Text>
        </Callout>
        {hasRan && (
          <SuccessMessage
            style={{marginTop: 16}}
            text="Successfully added Reaction."
          />
        )}
        <StepFooter
          disableNext={!isComplete && !hasRan}
          loading={loading}
          onPrevClick={this.handlePrevClick}
          onNextClick={this.handleNextClick}
        />
        {error && <ErrorMessage
          error={error}
        />}
      </Root>
    );
  }
}

export default withChat(Step4);
